// The staff social sign-in providers admin-web can offer (BL-2776). One list for the
// server (which are configured), the public availability route and the sign-in UI.

/** Every social provider a staff member can sign in with, in button order. */
export const SOCIAL_PROVIDER_IDS = ['google', 'apple'] as const;

/** A staff social sign-in provider id. */
export type SocialProviderId = (typeof SOCIAL_PROVIDER_IDS)[number];

/**
 * Narrows an arbitrary string (a URL segment, a query param) to a provider id.
 * @param value - The candidate string.
 * @returns True when `value` is one of {@link SOCIAL_PROVIDER_IDS}.
 */
export function isSocialProviderId(value: string): value is SocialProviderId {
  return (SOCIAL_PROVIDER_IDS as readonly string[]).includes(value);
}
